import React from 'react';
import { Colors } from '../../theme';

interface IconProps {
    icon: React.ReactNode;
    color?: Colors;
    backgroundColor?: Colors;
    size?: number;
    style?: React.CSSProperties;
}

const Icon = React.forwardRef<HTMLDivElement, IconProps & React.HTMLAttributes<HTMLDivElement>>(function Icon(
    { icon, color, backgroundColor, size = 30, style, ...rest },
    ref,
) {
    return (
        <div
            ref={ref}
            {...rest}
            style={{
                color: color || Colors.mediumTurq,
                backgroundColor: backgroundColor || Colors.lightTurq,
                width: size,
                height: size,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: size / 2,
                aspectRatio: '1',
                flexShrink: 0,
                ...style,
            }}
        >
            {icon}
        </div>
    );
});

export default Icon;
